<template>
  <div class="lucky-numbers container-custom">
    <div class="lucky-numbers__banner">
      <img src="@/assets/images/ticket/banner.webp" />
    </div>
    <div class="lucky-numbers__info">
        <div v-if="logo !== ''" class="lucky-numbers__info-flag">
          <img v-lazy="require(`@/assets/images/flags/${logo}.png`)" />
        </div>
      <div class="lucky-numbers__info-title">
        <span>{{ country }}</span> - <span>{{ name }}</span>
      </div>
      <div class="lucky-numbers__info-button">
        <button @click="handleGoBack()">GO BACK</button>
      </div>
    </div>
    <div v-if="isLoading">
      <loading />
    </div>
    <div v-show="!isLoading">
      <LuckyNumbersTable />
      <LuckyNumberMarket />
    </div>
  </div>
</template>
<script>
import LuckyNumbersTable from "./LuckyNumbersTable";
import LuckyNumberMarket from "./LuckyNumberMarket";
import Loading from '@/components/common/loading/Loading.vue'
export default {
  components: {
    LuckyNumbersTable,
    LuckyNumberMarket,
    Loading
  },
  data () {
    return {
      country: '',
      logo: '',
      name: ''
    }
  },
  computed: {
    listMarkets() {
      return this.$store.getters.getMarkets
    },
    isLoading () {
      return this.$store.state.isLoadingMarkets
    },
  },
  watch: {
    listMarkets(data) {
      this.logo = data.game.country_slug;
      this.country = data.game.country;
      this.name = data.game.name;
    }
  },
  beforeCreate() {
    this.$store.dispatch('apiGetMarkets', {slug: this.$store.state.paramsLuckyNumber?.slug})
    this.$store.dispatch('apiGetSettings')
  },
  methods: {
    handleGoBack() {
      this.$router.go(-1)
    }
  },
}
</script>
